<template>
    <div class="flex agenda-style overflow-x-hidden">
        <div class="flex-1 min-w-0 max-w-full md:max-w-[calc(100%-4rem)]">
            <AgendaListView
                :items="agenda"
                :selected_item="selected_item"
                class="agenda-list mb-0"
                :data-list_format="agendaListFormat"
                :level="0"
                :no_docs="false"
                :read_only="true"
                :meeting="meeting "
            ></AgendaListView>
            <div class="relative h-8 hidden md:block">
                <div class="absolute border -right-16 text-[10px] bottom-2 rounded text-center px-2 py-0.5 text-gray-700 z-10 border-gray-200 bg-gray-200">
                    <div class="absolute left-0 right-0 text-green text-xxs bold -top-2.5">END</div>
                    {{ endTime }}
                </div>
            </div>
        </div>

        <div class="hidden md:block w-16">
            <div class="w-16 flex h-full justify-center py-4">
                <div class="bg-gray-200 h-full relative left-1.5" style="width: 1px">&nbsp;</div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: "AgendaSimpleView",
    props: ['meeting', 'current_date', 'agendaListFormat', 'agendaItems'],
    data() {
        return {
            initialized: false,
            agenda: [],
            selected_item: null,
            sidebar_fixed: false,

        }
    },
    mounted() {
        this.fetchItems();
    },
    methods: {
        fetchItems(){
            this.agenda = this.agendaItems;
        },
    },
    computed: {
        endTime() {
            return this.current_date
                ? this.current_date.end
                : this.meeting.end;
        },
    },
    watch: {
        current_date() {
            this.fetchItems();
        },
        agendaItems() {
            this.fetchItems();
        },
    }
}

</script>
